// extracted by mini-css-extract-plugin
export var actions = "_dq-g";
export var benefitCard = "_dq-b";
export var benefitIcon = "_dq-d";
export var benefitLabel = "_dq-f";
export var benefits = "_dq-a";
export var benefitsSection = "_dq-8";
export var bodyText = "_dq-7";
export var closeButton = "_dq-2";
export var content = "_dq-3";
export var eyebrow = "_dq-4";
export var heading = "_dq-5";
export var image = "_dq-i";
export var imagePanel = "_dq-h";
export var modal = "_dq-0";
export var offerCard = "_dq-c";
export var offerIcon = "_dq-e";
export var sectionLabel = "_dq-9";
export var shell = "_dq-1";
export var title = "_dq-6";